import * as React from "react";
import { cn } from "../lib/utils";

/** Placeholder de carregamento: bloco cinza claro pulsando, com o tamanho do conteúdo que vai entrar. */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div aria-hidden className={cn("animate-pulse rounded-md bg-border", className)} {...props} />;
}

export { Skeleton };
